import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { DoodleToolbar as SharedDoodleToolbar, type DoodleToolbarProps as SharedDoodleToolbarProps } from '../../../../doodle-editor/doodle-toolbar';
import type { DoodleTool } from './use-doodle';

type DoodleToolbarProps = Omit<SharedDoodleToolbarProps, 'tool' | 'onToolChange' | 'translate' | 'saveLabel'> & {
	tool: DoodleTool;
	onToolChange: (tool: DoodleTool) => void;
};

export const DoodleToolbar: FC<DoodleToolbarProps> = ({ onToolChange, ...props }) => {
	const { t } = useTranslation('action_input');

	return <SharedDoodleToolbar {...props} onToolChange={onToolChange} translate={(key, options) => t(key, options)} saveLabel={t('doodle.done')} />;
};
